export default __webpack_public_path__ + "static/media/IFeelSick_14.274f0d93.png";